// extracted by mini-css-extract-plugin
export default {"socials":"Socials_socials__e4Tap"};